import React from "react";
import styles from "./index.module.scss";
import cn from "../../../../Utils/class-names.utils";

enum EmailTemplateId {
  Invites = 1,
  SecurityStackReport = 2,
}

interface EmailTemplate {
  id: number;
  title: string;
  subject: string;
}

interface IProps {
  onPreviewInviteTemplate: () => void;
}

const TemplatesTable = ({ onPreviewInviteTemplate }: IProps) => {
  const emailTemplates: EmailTemplate[] = [
    {
      id: EmailTemplateId.Invites,
      title: "Invites",
      subject: "You're invited to join HighGround via Portland",
    },
    {
      id: EmailTemplateId.SecurityStackReport,
      title: "Security Stack Report",
      subject: "Your Security Stack report is ready",
    },
  ];

  const handlePreviewAndEdit = (template: EmailTemplate) => {
    switch (template.id) {
      case EmailTemplateId.Invites: {
        onPreviewInviteTemplate()
        break;
      }
      case EmailTemplateId.SecurityStackReport: {
        break;
      }
    }
  };

  return (
    <div className={styles.table}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>Email Template</h1>
        </div>

        <div className={styles.headerSpacer} />
      </header>

      {emailTemplates.map((template, index) => (
        <article
          key={template.id}
          className={styles.article}
        >
          <div className={styles.content}>
            <h2 className={styles.templateTitle}>{template.title}</h2>

            <div className={styles.subjectContainer}>
              <span className={styles.subjectLabel}>Subject:</span>

              <p className={styles.subjectText}>{template.subject}</p>
            </div>
          </div>

          <button
            className={cn(styles.button, 'my-button')}
            type="button"
            aria-label={`Preview and edit ${template.title} email template`}
            onClick={() => handlePreviewAndEdit(template)}
          >
            <span className={styles.buttonContent}>
              <span className={styles.buttonText}>Preview &amp; Edit</span>
            </span>
          </button>
        </article>
      ))}
    </div>
  );
};

export default TemplatesTable;
